import * as ss from 'superstruct';
import { Id } from './types';
import { AdSources } from './conversions/tracking/paid-source.resource';

/** For retainers that don't fall specifically into a known ad source. */
export const OtherAdSource = 'other';

/**
 * How much a client pays AU each month for a particular ad source.
 *
 * Missing months use the most recent retainer.
 *
 * Set fee to 0 to indicate no retainer for that month.
 */
export const RetainerResource = ss.object({
  id: Id,

  /** Year this is for. */
  year: ss.number(),

  /** Month this is for [1, 12]. */
  month: ss.number(),

  /** The source of the ad spend. */
  adSource: ss.enums([...AdSources, OtherAdSource] as const),

  fee: ss.number(),
});

export type RetainerResource = ss.Infer<typeof RetainerResource>;
